export default "__VITE_ASSET__4ce85297__"